import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { Collapsible } from './Collapsible';
import { faqs } from '../data/landing';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-cream-200 px-4 py-11 sm:px-8 sm:py-16 lg:py-24" data-id="element-52" data-mp="1bmd6p6zvac52">
      <div className="mx-auto max-w-3xl" data-id="element-53" data-mp="1gk5aay9vjmp3">
        <h2 className="font-display text-2xl font-extrabold leading-tight text-ink-900 sm:text-4xl" data-id="element-54" data-mp="24969rw0qbni8">
          Preguntas frecuentes
        </h2>

        <div className="mt-5 divide-y divide-cream-300 border-y border-cream-300 sm:mt-10" data-id="element-55" data-mp="289hvzd8qpvvt">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.pregunta} data-id="element-56" data-mp="1zh6g2lb95qu3" data-mpi={index}>
                <h3 data-id="element-57" data-mp="1zg4wttk31y1a">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-4 py-3 text-left font-sans text-sm font-semibold leading-snug text-ink-900 transition-colors duration-150 ease-out hover:text-ink-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink-600 sm:gap-6 sm:py-5 sm:text-lg" data-id="element-58" data-mp="2n7imtsurhhj3">
                    {faq.pregunta}
                    <PlusIcon className={`mt-0.5 h-4 w-4 shrink-0 text-gold-600 transition-transform duration-200 ease-out sm:h-5 sm:w-5 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-59" data-mp="1ohygv3a7cme1" />
                  </button>
                </h3>

                <Collapsible id={`faq-panel-${index}`} open={isOpen} data-id="element-60" data-mp="35yhzn19szjb">
                  <p className="pb-4 pr-8 font-sans text-sm leading-relaxed text-ink-700 sm:pb-6 sm:pr-10 sm:text-base" data-id="element-61" data-mp="366tbahqvwse">
                    {faq.respuesta}
                  </p>
                </Collapsible>
              </div>;
        })}
        </div>
      </div>
    </section>;
}